var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.34 3.99h1.63V1.13A20.9 20.9 0 0012.59 1c-2.35 0-3.96 1.49-3.96 4.23v2.52h-2.6v3.2h2.6V19h3.18v-8.05h2.49l.4-3.2h-2.9v-2.2c0-.93.26-1.56 1.54-1.56z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0idGlueSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPg0KICA8cGF0aCBkPSJNMTMuMzQgMy45OWgxLjYzVjEuMTNBMjAuOSAyMC45IDAgMDAxMi41OSAxYy0yLjM1IDAtMy45NiAxLjQ5LTMuOTYgNC4yM3YyLjUyaC0yLjZ2My4yaDIuNlYxOWgzLjE4di04LjA1aDIuNDlsLjQtMy4yaC0yLjl2LTIuMmMwLS45My4yNi0xLjU2IDEuNTQtMS41NnoiLz4NCjwvc3ZnPg0K";
export { SvgFacebookBlack as ReactComponent };